import { render, staticRenderFns } from "./NormalSingle1.vue?vue&type=template&id=1d23d89c&"
import script from "./NormalSingle1.vue?vue&type=script&lang=js&"
export * from "./NormalSingle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports